import { render } from "./g-tab-menu.vue?vue&type=template&id=2216deca&scoped=true"
import script from "./g-tab-menu.vue?vue&type=script&lang=js"
export * from "./g-tab-menu.vue?vue&type=script&lang=js"

import "./g-tab-menu.vue?vue&type=style&index=0&id=2216deca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2216deca"]])

export default __exports__